import React from 'react';
import PropTypes from 'prop-types';
import { getMonthAndYearDateFormat } from 'helpers/DateHelper';

import Button from '@material-ui/core/Button';
import DatePicker from 'form/DatePicker';
import Form from 'form/Form';
import { TextField } from 'mui-rff';
import AdminFormWrapper from '../../presentational/AdminFormWrapper';
import AdminFormButtons from '../../presentational/AdminFormButtons';
import AdminFormFields from '../../presentational/AdminFormFields';

const SearchRoundReportsForm = ({ searchParameters, onSubmit, isSubmitting = false }) => {
    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={searchParameters}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormFields>
                            <DatePicker
                                name="createdTimeFrom"
                                label="Created from"
                                formatFunc={getMonthAndYearDateFormat}
                                inputVariant="outlined"
                                openTo="year"
                                views={['year', 'month']}
                            />
                            <DatePicker
                                name="createdTimeTo"
                                label="Created to"
                                formatFunc={getMonthAndYearDateFormat}
                                inputVariant="outlined"
                                openTo="year"
                                views={['year', 'month']}
                            />
                            <TextField
                                name="q"
                                label="Storage site or owner actor"
                                variant="outlined"
                            />
                        </AdminFormFields>
                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

SearchRoundReportsForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default SearchRoundReportsForm;
